import { render, staticRenderFns } from "./TrainingPlanItem.vue?vue&type=template&id=f179c016&scoped=true&"
import script from "./TrainingPlanItem.vue?vue&type=script&lang=ts&"
export * from "./TrainingPlanItem.vue?vue&type=script&lang=ts&"
import style0 from "./TrainingPlanItem.vue?vue&type=style&index=0&id=f179c016&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f179c016",
  null
  
)

export default component.exports